export default function promiseDelay(milliseconds: number) {
  return new Promise(resolve => setTimeout(resolve, milliseconds));
}
